// extracted by mini-css-extract-plugin
export default {"table":"platform-names_table__bkhA6"};